<script>
import { BFormSelectOptionGroup } from "bootstrap-vue";

export default {
  extends: BFormSelectOptionGroup
};
</script>